import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'
import { createTableSelector } from '../../../table/state/selector'
import { CUSTOMER_TABLE, CUSTOMER_PARTNER_TABLE } from './type'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const tableSelectorEmployee = createTableSelector(selectOwnState, CUSTOMER_TABLE)
export const tableSelectorPartner = createTableSelector(selectOwnState, CUSTOMER_PARTNER_TABLE)



// WEBPACK FOOTER //
// ./src/modules/customer/state/search/selector.js